import React from 'react';
import styled from 'styled-components';
import { colors, breakpoints } from '../../../assets/styles/GlobalStyles';

const StepIndicatorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  position: relative;

  /* Linha de conexão entre os passos */
  &::before {
    content: '';
    position: absolute;
    top: 20px;
    left: 10%;
    right: 10%;
    height: 2px;
    background: #e2e8f0;
    z-index: 0;
  }

  @media (max-width: ${breakpoints.mobile}) {
    &::before {
      left: 5%;
      right: 5%;
    }
  }
`;

const Step = styled.div`
  text-align: center;
  position: relative;
  z-index: 1;
  flex: 1;
`;

const StepNumber = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.$active ? colors.lightBlue : '#cbd5e1'};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0.5rem;
  font-weight: 600;
  transition: all 0.3s ease;
`;

const StepLabel = styled.div`
  font-size: 0.75rem;
  color: ${props => props.$active ? colors.darkBlue : '#64748b'};
  font-weight: ${props => props.$active ? '500' : '400'};

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.7rem;
  }
`;

/**
 * @param {number} currentStep - Passo atual do fluxo (1, 2 ou 3)
 */
const StepIndicator = ({ currentStep }) => {
  const steps = [
    { number: 1, label: 'Iniciar Protocolo' },
    { number: 2, label: 'Anexar Documentos' },
    { number: 3, label: 'Confirmação' }
  ];

  return (
    <StepIndicatorContainer>
      {steps.map(step => (
        <Step key={step.number}>
          <StepNumber $active={currentStep >= step.number}>
            {step.number}
          </StepNumber>
          <StepLabel $active={currentStep >= step.number}>
            {step.label}
          </StepLabel>
        </Step>
      ))}
    </StepIndicatorContainer>
  );
};

export default StepIndicator;
